import { render, staticRenderFns } from "./ContainerBox.vue?vue&type=template&id=75af59af&scoped=true"
import script from "./ContainerBox.vue?vue&type=script&lang=js"
export * from "./ContainerBox.vue?vue&type=script&lang=js"
import style0 from "./ContainerBox.vue?vue&type=style&index=0&id=75af59af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af59af",
  null
  
)

export default component.exports